import React from 'react';

import PropTypes from 'prop-types';

import { InputField } from 'components/FormHelper/InputField';
import { SectionSubtitle } from 'components/FormHelper/SectionSubtitle';

import {
  BRANCH_TYPE,
  BRANCH_TYPE_TO_GERMAN_NAME,
  BRANCH_TYPE_TO_VARIABLE_NAME,
  EIV_STATUS,
} from 'global/constants';

import { isRegisteredBranchMain } from 'utils/InstallerUtils';

import { SecondQualification } from './SecondQualification';

const STATUSES_TO_RENDER_SECTION_TITLE = [EIV_STATUS.ACTIVE, EIV_STATUS.NEW];

const renderSectionTitle = (statusEnergy, statusGas, branch) => {
  if (
    STATUSES_TO_RENDER_SECTION_TITLE.includes(statusEnergy) &&
    STATUSES_TO_RENDER_SECTION_TITLE.includes(statusGas)
  ) {
    return (
      <SectionSubtitle>Qualifikationen – {BRANCH_TYPE_TO_GERMAN_NAME[branch]}</SectionSubtitle>
    );
  }
  return null;
};
const shouldRenderQualificationForBranch = (branch, installerStatusSummary, formik) => {
  return (
    isRegisteredBranchMain(installerStatusSummary, branch) &&
    formik.values[`isExpert${BRANCH_TYPE_TO_VARIABLE_NAME[branch]}Active`]
  );
};
export const DEBExpertQualificationSection = ({
  formik,
  installerStatusSummary,
  firstQualificationGasItems,
  firstQualificationEnergyItems,
}) => (
  <>
    {shouldRenderQualificationForBranch(BRANCH_TYPE.ENERGY, installerStatusSummary, formik) && (
      <>
        {renderSectionTitle(
          formik.values.statusEnergy,
          formik.values.statusGas,
          BRANCH_TYPE.ENERGY
        )}
        <div className="popup-content__popup-field">
          <InputField
            fullWidth
            select
            items={firstQualificationEnergyItems}
            label="Qualifikation wählen*"
            onChange={formik.handleChange}
            name="firstQualificationEnergy"
            id="firstQualificationEnergy"
            error={Boolean(formik.errors.firstQualificationEnergy)}
            value={formik.values.firstQualificationEnergy}
            oldValue=""
          />
        </div>
        <SecondQualification
          formik={formik}
          selectedBranch={BRANCH_TYPE.ENERGY}
          firstQualificationValue={formik.values.firstQualificationEnergy}
          secondQualificationName="secondQualificationEnergy"
          secondQualificationError={formik.errors.secondQualificationEnergy}
          secondQualificationValue={formik.values.secondQualificationEnergy}
        />
      </>
    )}
    {shouldRenderQualificationForBranch(BRANCH_TYPE.GAS, installerStatusSummary, formik) && (
      <>
        {renderSectionTitle(formik.values.statusEnergy, formik.values.statusGas, BRANCH_TYPE.GAS)}
        <div className="popup-content__popup-field">
          <InputField
            fullWidth
            select
            items={firstQualificationGasItems}
            label="Qualifikation wählen*"
            onChange={formik.handleChange}
            name="firstQualificationGas"
            id="firstQualificationGas"
            error={Boolean(formik.errors.firstQualificationGas)}
            value={formik.values.firstQualificationGas}
            oldValue=""
          />
        </div>
        <SecondQualification
          formik={formik}
          selectedBranch={BRANCH_TYPE.GAS}
          firstQualificationValue={formik.values.firstQualificationGas}
          secondQualificationName="secondQualificationGas"
          secondQualificationError={formik.errors.secondQualificationGas}
          secondQualificationValue={formik.values.secondQualificationGas}
        />
      </>
    )}
  </>
);

DEBExpertQualificationSection.propTypes = {
  formik: PropTypes.object.isRequired,
  installerStatusSummary: PropTypes.object.isRequired,
  firstQualificationGasItems: PropTypes.array.isRequired,
  firstQualificationEnergyItems: PropTypes.array.isRequired,
};
